import React, { useState } from 'react';
import createBonusUI from '@voogo/bonus-ui';
import '@voogo/bonus-ui/style.css';
import api from '../services/api';
const { CampaignManager, QualificationOverview } = createBonusUI(React);
export default function BonusCampaignList(){
  const [overview,setOverview]=useState(null);
  return <><CampaignManager api={api} scope="partners" onLoaded={setOverview}/><QualificationOverview data={overview}/></>;
}
